import { rawHirerAccountInfo } from '../services/mockDataService/mockHeaderFooterContext';

export const getLocalAccountInfo = () => {
  let account: any = {};
  account = rawHirerAccountInfo;
  return account;
};

export const getWindowLocation = (): {
  href: string;
  origin: string;
  pathname: string;
  search: string;
} => {
  if (typeof window === 'undefined' || window === null) {
    return {
      href: '',
      origin: '',
      pathname: '',
      search: '',
    };
  }
  return window.location;
};
